import React,{useState,useEffect} from 'react'
import Box from '@mui/material/Box';
import {Typography,Button,Grid,Grow,Fade, Link} from '@mui/material';
import {makeStyles} from '@mui/styles';
import Divider from '@mui/material/Divider';
import Slide from '@mui/material/Slide';

const useStyles = makeStyles((theme)=>({
    aboutContainer:{
        width:'99%',
        height:'700px',
        display:'flex',
        justifyContent:'center',
       
        alignItems:'center',
        [theme.breakpoints.down("800")]:{
            alignItems:'normal',
            height:'100%'
        }
    },
    aboutHeader:{
        color:'#64ffda',
        fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",
        fontSize:'10vw',
        

    },aboutMe:{
        marginInline:'10px',color:'#ccd6f6',
        [theme.breakpoints.down("800")]:{
            fontSize:'8vw'
           
        }
    },
    imageContainer:{
        "&:hover":{
            border:'5px solid #64ffda'
        },
        width:'20vw',
        height:'auto',
        border:'1px solid #64ffda',
        [theme.breakpoints.down("800")]:{
            marginTop:'25px',
            width:'33vh',
            height:'35vh'
          }
    },image:{
        width:'20vw',
        height:'auto',
        backgroundColor:'#64ffda',
        color:'#64ffda',
        opacity:'0.85',
        "&:hover":{
            opacity:'1'
        },
        [theme.breakpoints.down("800")]:{
            opacity:'1',
            width:'33vh',
            height:'35vh'
          }
    },
    divider:{
        width:'200px',
        backgroundColor:'#233554',
        alignSelf:'center',
        [theme.breakpoints.down("800")]:{
          width:'50px'
        }
    },
    aboutMeContainer:{
        [theme.breakpoints.down("800")]:{
            margin:'25px 0px 25px 0px'
          }  
    }

}))

const About = ({refer}) => {
    const classes = useStyles()
    const [windowWidth, setWindowWidth] = useState(window.innerWidth)
    const [openDrawer,setOpenDrawer] = useState(false)
    const [focusedStatus,setFocusedStatus] = useState(false)
   useEffect(()=>{
   
   },[refer])

    useEffect(()=>{
        document.addEventListener("focusin",()=>{
          
            setFocusedStatus(true)
        })
        
        return ()=>document.removeEventListener("focusin",()=>{setFocusedStatus(true)})
    },[])

    useEffect(()=>{
        window.addEventListener("focusout",()=>{setFocusedStatus(false)})
        return ()=>document.removeEventListener("focusout",()=>{setFocusedStatus(false)})
    },[])

     useEffect(() => {
       function handleResize() {
         setWindowWidth(window.innerWidth)
       }
       
       window.addEventListener('resize', handleResize)
       return () => window.removeEventListener('resize', handleResize)
     }, [])
    return (
        <div ref={refer}>
            <Box className={classes.aboutContainer}>
                <Grid container style={{width:'80%'}}>

                    <Grid item xs={12} lg={4} md={4}>
                            <Box className={classes.imageContainer} >
                                
                                <img
                                    className={classes.image}
                                    src={"https://firebasestorage.googleapis.com/v0/b/suprith-hattikal.appspot.com/o/PorfolioImage.jpg?alt=media&token=b5ff127d-3395-4021-81e3-924a2186bae6"}
                                    alt="Suprith Hattikal"
                                />
                            
                            </Box>
                        

                    </Grid>

                    <Grid item xs={12} lg={8} md={8}>
                        <Box style={{display:'flex',flexDirection:'row'}} className={classes.aboutMeContainer}>
                            <Typography className={classes.aboutHeader} style={{fontSize:'22px',alignSelf:'center'}}>01.</Typography>
                            <Typography className={classes.aboutMe} style={{fontSize:'26px',fontWeight:'600',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text"}}>About Me</Typography>
                            <Divider orientation="horizontal"  className={classes.divider}/>
                        </Box>
                        <Box>
                            <Typography style={{color:"#8892b0",fontSize:'18px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",maxWidth:'600px'}}>
                                    Hello! My name is Suprith and I enjoy creating things that live on the internet.I am a Software Engineer with experience in Python,GoLang, Cpp ,C ,Javascript and Java. Currently, I work at Juniper Networks, where I build solutions aligning with OpenConfig standards and create internal tools to improve productivity.

                                    I have experience developing Python APIs, optimizing algorithms, and contributing to Google's open-source ONDATRA project. My projects range from full-stack web apps to desktop software, showcasing my versatility in problem-solving and creating impactful solutions.

                                    I enjoy learning and applying new technologies, especially in backend development, APIs, and automation. Let's connect to discuss opportunities and ideas in Python, GoLang, or software development!
                            </Typography>

                            <Typography style={{color:"#8892b0",fontSize:'18px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",maxWidth:'600px',marginTop:'10px'}}>
                                Fast-forward to today, I have been working as a Software Engineer 2 at Juniper Networks. My main focus these days is building accessible, inclusive products and digital experiences.
                            </Typography>

                            <Typography style={{color:"#8892b0",fontSize:'18px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",maxWidth:'600px',marginTop:'10px'}}>
                                I have also published articles  
                                <Link style={{color:"#64ffda",textDecoration:'none',marginInline:'5px'}} href="https://hackernoon.com/how-to-integrate-the-paytm-payment-gateway-in-your-react-native-apps" target="_blank">Integrating PayTm payment gateway in React-Native</Link>,
                                <Link style={{color:"#64ffda",textDecoration:'none',marginInline:'5px'}} href="https://hackernoon.com/using-core-node-js-modules-in-react-native-apps-4z1c3734" target="_blank">Using Core Node-js modules in React-Native</Link>,
                                <Link style={{color:"#64ffda",textDecoration:'none',marginInline:'5px'}} href="https://ieeexplore.ieee.org/document/10141161" target="_blank">Identification of Disease in Cassava Leaf using Deep Learning</Link>.
                            </Typography>

                            <Typography style={{color:"#8892b0",fontSize:'18px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",maxWidth:'600px',marginTop:'15px'}}>
                            Here are a few technologies I’ve been working with recently:
                            </Typography>

                            
                            <Grid container direction="row">
                                <Grid item lg={4} xs={4} md={4}>
                                    
                                    <Box style={{display:'flex',flexDirection:'row'}}>
                                        <span style={{color:'#64ffda',fontSize:"25px",paddingRight:'10px'}}>&#8227;</span>
                                        <Typography variant="body2"  style={{color:"#8892b0",fontSize:'15px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",maxWidth:'600px',marginTop:'10px'}}>Python</Typography>
                                    </Box>

                                    <Box style={{display:'flex',flexDirection:'row'}}>
                                        <span style={{color:'#64ffda',fontSize:"25px",paddingRight:'10px'}}>&#8227;</span>
                                        <Typography variant="body2"  style={{color:"#8892b0",fontSize:'15px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",maxWidth:'600px',marginTop:'10px'}}>Go Lang</Typography>
                                    </Box>
                                    
                                    <Box style={{display:'flex',flexDirection:'row'}}>
                                        <span style={{color:'#64ffda',fontSize:"25px",paddingRight:'10px'}}>&#8227;</span>
                                        <Typography variant="body2"  style={{color:"#8892b0",fontSize:'15px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",maxWidth:'600px',marginTop:'10px'}}>C and C++</Typography>
                                    </Box>

                                    <Box style={{display:'flex',flexDirection:'row'}}>
                                        <span style={{color:'#64ffda',fontSize:"25px",paddingRight:'10px'}}>&#8227;</span>
                                        <Typography variant="body2"  style={{color:"#8892b0",fontSize:'15px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",maxWidth:'600px',marginTop:'10px'}}>Javascript</Typography>
                                    </Box>
                                    <Box style={{display:'flex',flexDirection:'row'}}>
                                        <span style={{color:'#64ffda',fontSize:"25px",paddingRight:'10px'}}>&#8227;</span>
                                        <Typography variant="body2"  style={{color:"#8892b0",fontSize:'15px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",maxWidth:'600px',marginTop:'10px'}}>Java</Typography>
                                    </Box>

                                    <Box style={{display:'flex',flexDirection:'row'}}>
                                        <span style={{color:'#64ffda',fontSize:"25px",paddingRight:'10px'}}>&#8227;</span>
                                        <Typography variant="body2"  style={{color:"#8892b0",fontSize:'15px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",maxWidth:'600px',marginTop:'10px'}}>Node.js</Typography>
                                    </Box>
                                </Grid>

                                <Grid item lg={4} xs={4} md={4}>
                                    

                                    <Box style={{display:'flex',flexDirection:'row'}}>
                                        <span style={{color:'#64ffda',fontSize:"25px",paddingRight:'10px'}}>&#8227;</span>
                                        <Typography variant="body2"  style={{color:"#8892b0",fontSize:'15px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",maxWidth:'600px',marginTop:'10px'}}>React and React-Native</Typography>
                                    </Box>
                                    
                                    <Box style={{display:'flex',flexDirection:'row'}}>
                                        <span style={{color:'#64ffda',fontSize:"25px",paddingRight:'10px'}}>&#8227;</span>
                                        <Typography variant="body2"  style={{color:"#8892b0",fontSize:'15px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",maxWidth:'600px',marginTop:'10px'}}>Express.js</Typography>
                                    </Box>

                                    <Box style={{display:'flex',flexDirection:'row'}}>
                                        <span style={{color:'#64ffda',fontSize:"25px",paddingRight:'10px'}}>&#8227;</span>
                                        <Typography variant="body2"  style={{color:"#8892b0",fontSize:'15px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",maxWidth:'600px',marginTop:'10px'}}>Django</Typography>
                                    </Box>
                                    
                                    <Box style={{display:'flex',flexDirection:'row'}}>
                                        <span style={{color:'#64ffda',fontSize:"25px",paddingRight:'10px'}}>&#8227;</span>
                                        <Typography variant="body2"  style={{color:"#8892b0",fontSize:'15px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",maxWidth:'600px',marginTop:'10px'}}>Flask</Typography>
                                    </Box>

                                    <Box style={{display:'flex',flexDirection:'row'}}>
                                        <span style={{color:'#64ffda',fontSize:"25px",paddingRight:'10px'}}>&#8227;</span>
                                        <Typography variant="body2"  style={{color:"#8892b0",fontSize:'15px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",maxWidth:'600px',marginTop:'10px'}}>HTML && CSS & Bootstrap</Typography>
                                    </Box>

                                    <Box style={{display:'flex',flexDirection:'row'}}>
                                        <span style={{color:'#64ffda',fontSize:"25px",paddingRight:'10px'}}>&#8227;</span>
                                        <Typography variant="body2"  style={{color:"#8892b0",fontSize:'15px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",maxWidth:'600px',marginTop:'10px'}}>Docker</Typography>
                                    </Box>
                                </Grid>

                                <Grid item lg={4} xs={4} md={4}>
                                
                                    <Box style={{display:'flex',flexDirection:'row'}}>
                                        <span style={{color:'#64ffda',fontSize:"25px",paddingRight:'10px'}}>&#8227;</span>
                                        <Typography variant="body2"  style={{color:"#8892b0",fontSize:'15px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",maxWidth:'600px',marginTop:'10px'}}>Kubernetes</Typography>
                                    </Box>
                                    
                                    <Box style={{display:'flex',flexDirection:'row'}}>
                                        <span style={{color:'#64ffda',fontSize:"25px",paddingRight:'10px'}}>&#8227;</span>
                                        <Typography variant="body2"  style={{color:"#8892b0",fontSize:'15px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",maxWidth:'600px',marginTop:'10px'}}>Linux</Typography>
                                    </Box>

                                    <Box style={{display:'flex',flexDirection:'row'}}>
                                        <span style={{color:'#64ffda',fontSize:"25px",paddingRight:'10px'}}>&#8227;</span>
                                        <Typography variant="body2"  style={{color:"#8892b0",fontSize:'15px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",maxWidth:'600px',marginTop:'10px'}}>Firebase</Typography>
                                    </Box>

                                    <Box style={{display:'flex',flexDirection:'row'}}>
                                        <span style={{color:'#64ffda',fontSize:"25px",paddingRight:'10px'}}>&#8227;</span>
                                        <Typography variant="body2"  style={{color:"#8892b0",fontSize:'15px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",maxWidth:'600px',marginTop:'10px'}}>PSQL & MYSQL</Typography>
                                    </Box>

                                    <Box style={{display:'flex',flexDirection:'row'}}>
                                        <span style={{color:'#64ffda',fontSize:"25px",paddingRight:'10px'}}>&#8227;</span>
                                        <Typography variant="body2"  style={{color:"#8892b0",fontSize:'15px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",maxWidth:'600px',marginTop:'10px'}}>AI/Deep Learning/Machine Learning</Typography>
                                    </Box>


                                </Grid>

                                <Grid item lg={4} xs={4} md={4}>
                                   
                                   
                                    
                                    {/* <Box style={{display:'flex',flexDirection:'row'}}>
                                        <span style={{color:'#64ffda',fontSize:"25px",paddingRight:'10px'}}>&#8227;</span>
                                        <Typography variant="body2"  style={{color:"#8892b0",fontSize:'15px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",maxWidth:'600px',marginTop:'10px'}}>Data Structures, Algorithms, computer fundamentals,</Typography>
                                    </Box>

                                    
                                    <Box style={{display:'flex',flexDirection:'row'}}>
                                        <span style={{color:'#64ffda',fontSize:"25px",paddingRight:'10px'}}>&#8227;</span>
                                        <Typography variant="body2"  style={{color:"#8892b0",fontSize:'15px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",maxWidth:'600px',marginTop:'10px'}}>Networking fundamentals,REST-API,AWS,OOP,MYSQL</Typography>
                                    </Box>

                                    <Box style={{display:'flex',flexDirection:'row'}}>
                                        <span style={{color:'#64ffda',fontSize:"25px",paddingRight:'10px'}}>&#8227;</span>
                                        <Typography variant="body2"  style={{color:"#8892b0",fontSize:'15px',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",maxWidth:'600px',marginTop:'10px'}}>Design Patterns</Typography>
                                    </Box> */}

                                </Grid>
                            </Grid>

                           

                        </Box>
                    </Grid>
                    

                </Grid>
                
               
            </Box>
            
        </div>
    )
}

export default About
